import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from './MobileTrend.module.css';
import { fetchTrendtocks, selectTrendStocks } from "../../trend/TrendSlice";
import { Table, Pagination } from "rsuite";
import { selectUserWatchlist, selectIndices } from "../../watchlist/WatchlistSlice";
import "rsuite/dist/rsuite.min.css";
import "../../../util/css/Table.css";
import downArrow from '../../../assets/image/dashboard-images/image 8.png'
import { FiChevronsRight } from "react-icons/fi";
import { FiChevronsLeft } from "react-icons/fi";
import TrendCard from '../../trend/TrendCard';
import MobileTrendCard from "../../trend/MobileTrendCard";
import ScrollToTop from "../../../components/ScrollToTop/ScrollToTop";

const MobileTrend = () => {

    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [trendType, setTrendType] = useState('D');

    const { Column, HeaderCell, Cell } = Table;
    const dispatch = useDispatch();
    const trend_stocks = useSelector(selectTrendStocks);
    const watchlists = useSelector(selectUserWatchlist) || [];
    const indices = useSelector(selectIndices) || [];
    const [watchlistSelected, setWatchlistSelected] = useState('');
    const [indexSelected, setIndexSelected] = useState('');

    const [trendCardsPerPage, setTrendCardsPerPage] = useState(12);
    const [currentPage, setCurrentPage] = useState(1);



    useEffect(() => {
        if (!indices || indices.length === 0) return;

        setIndexSelected(indices[0].indexUId);
        const req = {
            indexUId: indices[0].indexUId
        };
        dispatch(fetchTrendtocks(req));
    }, [dispatch, indices]);

    const handleChangeLimit = (dataKey) => {
        setPage(1);
        setLimit(dataKey);
    };

    const typeMap = {
        'D': { key: 'day', trendKey: 'day.trend', percentagekey: 'day.percentage_diff', supportKey: 'day.support', resistanceKey: 'day.resistance' },
        'W': { key: 'week', trendKey: 'week.trend', percentagekey: 'week.percentage_diff', supportKey: 'week.support', resistanceKey: 'week.resistance' },
        'M': { key: 'month', trendKey: 'month.trend', percentagekey: 'month.percentage_diff', supportKey: 'month.support', resistanceKey: 'month.resistance' },
    }

    const handleGroupSelection = (value, flag) => {
        if (flag === "W") {
            setWatchlistSelected(value);
            setIndexSelected("");
        } else {
            setWatchlistSelected("");
            setIndexSelected(value);
        }

        setTimeout(() => {
            getTrends();
        }, 0);
    }

    const getTrends = () => {
        const req = {};
        if (indexSelected) {
            req.indexUId = indexSelected;
        } else if (watchlistSelected) {
            req.watchlistUId = watchlistSelected;
        }
        dispatch(fetchTrendtocks(req));
    }

    // --------------------------------------------------------

    const numOfTotalPages = Math.ceil(trend_stocks.length / trendCardsPerPage)
    let leftPageBound, rightPageBound;

    if (currentPage === numOfTotalPages) {
        leftPageBound = Math.max(numOfTotalPages - 2, 1);
        rightPageBound = numOfTotalPages;
    } else if (currentPage === 1) {
        leftPageBound = 1;
        rightPageBound = Math.min(numOfTotalPages, currentPage + 2);
    } else {
        leftPageBound = Math.max(currentPage - 1, 1);
        rightPageBound = Math.min(currentPage + 1, numOfTotalPages);
    }

    const pages = Array.from({ length: rightPageBound - leftPageBound + 1 }, (_, i) => leftPageBound + i);


    const indexOfLastCard = currentPage * trendCardsPerPage;
    const indexOfFirstCard = indexOfLastCard - trendCardsPerPage;

    const visibleCards = trend_stocks.slice(indexOfFirstCard, indexOfLastCard)

    const prevPageHandler = () => {
        if (currentPage !== 1) setCurrentPage(currentPage - 1)
    }

    const nextPageHandler = () => {
        if (currentPage !== numOfTotalPages) setCurrentPage(currentPage + 1)
    }

    const getValidTrend = (item) => {
        if (trendType == 'D') {
            if (item.day.trend !== 'NA') return true;
            return false;
        } else if (trendType == 'W') {
            if (item.week.trend !== 'NA') return true;
            return false;
        } else if (trendType == 'M') {
            if (item.month.trend !== 'NA') return true;
            return false;

        }
    }

    // --------------------------------------------------------

    return (
        <div className={` ${styles.wrapper}`}>

            <div>
                {trend_stocks && (
                    <>
                        <div className={styles.filter_section}>

                            <div className={styles.trends_dropdown_wrapper}>
                                <div className={styles.floating_select_wrapper}>
                                    <select
                                        className={`${watchlistSelected === '' ? styles.grey_text : styles.black_text}`}
                                        value={watchlistSelected}
                                        onChange={(event) => handleGroupSelection(event.target.value, 'W')}
                                        required
                                        placeholder=" "
                                    >
                                        <option disabled value="">Select Watchlist</option>
                                        {watchlists.map((item, index) => (
                                            <option key={index} value={item.watchlistUId}>
                                                {item.watchlistName}
                                            </option>
                                        ))}
                                    </select>
                                    <label className={styles.floating_label}>Watchlist</label>
                                </div>
                            </div>

                            <div className={styles.trends_dropdown_wrapper}>
                                <div className={styles.floating_select_wrapper}>
                                    <select className={`${indexSelected === '' ? styles.grey_text : styles.black_text}`} value={indexSelected} onChange={(event) => handleGroupSelection(event.target.value, "I")}>
                                        <option disabled value=''>Select Index</option>
                                        {
                                            indices.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.indexUId}>{item.indexName}</option>
                                                )
                                            })
                                        }
                                    </select>
                                    <label className={styles.floating_label}>Index</label>
                                </div>
                            </div>

                            {/* <div className={styles.trends_btn_wrapper}>
                                <input type="button" value='VIEW' onClick={getTrends} className={styles.trends_filter_btn} />
                            </div> */}
                        </div>


                        <div className={styles.closing_style}>
                            <span className="close-text">Closing basis on : </span>
                            <input type="button" value='DAILY' className={`${styles.closing_basis_btn} ${trendType === "D" ? styles.active : ""}`} onClick={() => setTrendType('D')}></input>
                            <input type="button" value='WEEKLY' className={`${styles.closing_basis_btn} ${trendType === "W" ? styles.active : ""}`} onClick={() => setTrendType('W')}></input>
                            <input type="button" value='MONTHLY' className={`${styles.closing_basis_btn} ${trendType === "M" ? styles.active : ""}`} onClick={() => setTrendType('M')}></input>
                        </div>



                        <div className={styles.trends_card_grid}>
                            <div className="row">
                                {trend_stocks.map((item, index) => {
                                    return (
                                        getValidTrend(item) && (
                                            <MobileTrendCard
                                                key={index}
                                                item={item}
                                                trendType={trendType}
                                            />
                                        )
                                    );
                                })}
                            </div>
                        </div>

                        {/* ========== pagination starts ============= */}
                        {/* <div className='pagination-container'>
                            <div className='pagination-wrapper'>

                                <button onClick={prevPageHandler} className={currentPage === 1 ? "disabled-button" : ""}><FiChevronsLeft /></button>
                                <div className='pagination-item-wrapper'>
                                    {pages.map((page) => (
                                        <span
                                            key={page}
                                            onClick={() => setCurrentPage(page)}
                                            className={`${currentPage === page ? "active-notifications" : "pagination-item"}`}
                                        >{`${page}`}</span>
                                    ))}
                                </div>
                                <button onClick={nextPageHandler} className={currentPage === numOfTotalPages ? "disabled-button" : ""}><FiChevronsRight /></button>

                            </div>
                        </div> */}
                        {/* ========== pagination starts ============= */}
                    </>
                )}
            </div>
            <ScrollToTop />
        </div>
    )
}

export default MobileTrend